<div class="sidebar-backdrop" appMobileSidebarBackdrop></div>
<div class="sidebar" [class.sidebar-suppressed]="suppressNav">
  <app-sidebar-header [navigation]="navigation"></app-sidebar-header>
  <!-- 
  <app-sidebar-form *ngIf="navigation.hasButton"></app-sidebar-form>
   -->
  <app-sidebar-nav [navigation]="navigation"></app-sidebar-nav>
  <app-sidebar-footer></app-sidebar-footer>
</div>
